import { Box, Grid } from '@mui/material';
import { savePDF } from '@progress/kendo-react-pdf';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logo from 'src/assets/images/logos/washingtonmills_logo.png';
import { PrimaryButton } from 'src/components/shared/Button/Button';
import { InputField } from 'src/components/shared/Forms/Input/InputField';
import { ProductDetailDto } from 'src/store/products/product';
import styled from 'styled-components';
import { ProductSampleLabelBody } from './ProductSampleLabelBody';

type ProductSampleLabelProps = {
  product: ProductDetailDto;
};

export const ProductSampleLabel: React.FC<ProductSampleLabelProps> = ({
  product
}) => {
  const { t } = useTranslation();
  const [weight, setWeight] = useState('');

  const [isPrinting, setIsPrinting] = useState<boolean>(false);
  const labelsRef = useRef<HTMLDivElement>(null);

  const onPrint = async () => {
    setIsPrinting(true);
    await savePDF(labelsRef.current as HTMLElement, {
      fileName: 'productsample.pdf',
      forcePageBreak: '.page-break'
    });
    setIsPrinting(false);
  };

  return (
    <Grid container>
      <Grid item xs={8}>
        <Box display="flex" gap="1.5rem">
          <InputField
            value={weight}
            label={'weight'}
            onChange={event => {
              setWeight(event.target.value);
            }}
          />
        </Box>

        <LabelWrapper ref={labelsRef} className={isPrinting ? 'printing' : ''}>
          <LabelHeader>
            <img src={logo} alt="LIMS logo" />
          </LabelHeader>
          <ProductSampleLabelBody product={product} weight={weight} />
        </LabelWrapper>
        <Box display="flex" gap="1.5rem" marginTop="2rem">
          <PrimaryButton onClick={onPrint} disabled={isPrinting}>
            {t('print')}
          </PrimaryButton>
        </Box>
      </Grid>
    </Grid>
  );
};

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3);
  background-color: #fff;
  color: #333;
  width: 54mm;
  padding: 20px 5px 20px 5px;

  &.printing textarea {
    border: 0;
    resize: none;
  }
`;

const LabelHeader = styled.div`
  margin-bottom: 8px;

  img {
    width: 100%;
  }
`;
